import {Modal} from "@mui/material";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import {observer} from "mobx-react";
import React from "react";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {ReactComponent as IconInfo} from "assets/img/icon/icon-info-navy-blue.svg";
import {IInfoSessionModalController} from "views/components/modals/info_session_modal/info_session_modal.controller";
import {PrimaryButton} from "views/components/style";

export const InfoSessionModal: React.FC = observer(() => {
	const {data, open, onButtonClick, close} = useViewController<IInfoSessionModalController>(
		Bindings.InfoSessionModalController
	);

	const {title, message, button} = data;

	return (
		<Modal open={open}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconInfo />
					</ModalHeader>
					<ModalBody>
						<ModalTitle style={{marginBottom: 25, marginTop: 15}}>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<PrimaryButton onClick={onButtonClick} size="large">
							{button}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
